import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import { cx } from 'utils/cx'
import styles from './ColorSelectorCounter.module.css'

export function ColorSelectorCounter({
	count,
	className,
	'data-testid': dataTestId,
	selected = false,
}: Readonly<{
	/** Number of extra colors */
	count: number
	className?: string
	'data-testid'?: string
	/** The control is selected by the user */
	selected?: boolean
}>): React.ReactNode {
	return (
		<span
			className={cx(
				className,
				styles.colorSelectorCounter,
				selected && styles.selected,
				textBodyM.className
			)}
			data-testid={dataTestId}
		>
			+{count}
		</span>
	)
}
